module.exports = __webpack_public_path__ + "static/7-1c03cfa9368913ce0a1688864e8652e3.jpg";